import { render } from "./TermTranslationList.vue?vue&type=template&id=473464b3"
import script from "./TermTranslationList.vue?vue&type=script&lang=js"
export * from "./TermTranslationList.vue?vue&type=script&lang=js"

import "./TermTranslationList.vue?vue&type=style&index=0&id=473464b3&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__